import { gql } from "@apollo/client";

export const MEAL = gql`
  query Meal($culture: String!, $status: Status!) {
    meal(where: {localization: {culture: $culture}}, status: $status) {
      code {
        code
      }
      name
      description
      image {
        paths(first: 1)
        texts(first: 1)
      }
    }
  }
`